import { useEffect } from 'react'
import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { EmailsFilterKey } from 'api/Trading-Accounts/Types/EmailsDetailsDto'
import { SelectFilter } from 'components/Filter/SelectFilter'
import { YesNoFilter } from 'components/Filter/YesNoFilter'
import { useAppDispatch, useAppSelector } from 'store'
import { fetchEmailFromTypes, fetchEmailGroupTypes } from 'store/clientarea/clientarea.actions'
import { FilterProps } from 'store/grid/types'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'
import { useApiClient } from 'utils/api/ApiClient'
import { ClientAreaApiClient } from 'utils/api/clientAreaApi'

const GroupFilter: React.FC<FilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const emailGroupTypes = useAppSelector((state) => state.clientArea.emailGroupTypes)
  const dispatch = useAppDispatch()
  const clientAreaApiClient = useApiClient(ClientAreaApiClient)

  const data = (emailGroupTypes ?? []).map((x) => ({ id: x.id, label: x.name, value: x.id }))

  useEffect(() => {
    if (!emailGroupTypes?.length) dispatch(fetchEmailGroupTypes(clientAreaApiClient))
  }, [emailGroupTypes])

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}

const FromFilter: React.FC<FilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const emailFromTypes = useAppSelector((state) => state.clientArea.emailFromTypes) ?? []
  const dispatch = useAppDispatch()
  const clientAreaApiClient = useApiClient(ClientAreaApiClient)

  const data = (emailFromTypes ?? []).map((x) => ({ id: x.id, label: x.name, value: x.id }))

  useEffect(() => {
    if (!emailFromTypes?.length) dispatch(fetchEmailFromTypes(clientAreaApiClient))
  }, [emailFromTypes])

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}

export const getEmailFilterFields = (): FieldSettings[] => [
  {
    name: EmailsFilterKey.name,
    label: 'Name',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.startsWithOperator,
        operator: GridFilterOperatorEnum.startsWithOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notStartsWithOperator,
        operator: GridFilterOperatorEnum.notStartsWithOperator,
      },
    ],
  },
  {
    name: EmailsFilterKey.subject,
    label: 'Subject',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.startsWithOperator,
        operator: GridFilterOperatorEnum.startsWithOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notStartsWithOperator,
        operator: GridFilterOperatorEnum.notStartsWithOperator,
      },
    ],
  },
  {
    name: EmailsFilterKey.fromType,
    label: 'From Type',
    filter: FromFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: EmailsFilterKey.group,
    label: 'Group',
    filter: GroupFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: EmailsFilterKey.archive,
    label: 'Archive',
    filter: YesNoFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
]
